import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ReportForest } from 'src/app/models/reportForest.model';
import { AutoSaveComponent } from '../../report-2500-8/auto-save/auto-save.component';
import { NAFilterPipe } from 'src/pipes/naFilter.pipe';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';

@Component({
  selector: 'app-accomplishment-details',
  templateUrl: './accomplishment-details.component.html',
  styleUrls: ['./accomplishment-details.component.scss'],
  standalone: false
})

export class AccomplishmentDetailsComponent extends AutoSaveComponent implements OnChanges, OnInit {
  //icons
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;

  html = "<p>Hello</p>"

  report = input.required<any>();
  reportList = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();

  totalFunding = 0;

  form = this.formBuilder.group({
    report_name: [""],
    report_type: [""],
    h_code: ["", Validators.maxLength(10)],
    date_contained: [null] as unknown as Date[],
    prepared_name: ["", Validators.maxLength(50)],
    prepared_address: ["", Validators.maxLength(100)],
    prepared_number: ["", Validators.maxLength(15)],
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly accomplishmentService: AccomplishmentService,
    private readonly toast: ConfirmationToastComponent,
    private readonly naFilter: NAFilterPipe,
  ) {
    super()
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.getTotalFunding();

    this.form.patchValue({
      report_name: this.report().report_name,
      report_type: this.report().report_type,
      h_code: this.report().h_code,
      date_contained: this.report().date_contained,
      prepared_name: this.report().prepared_name,
      prepared_address: this.report().prepared_address,
      prepared_number: this.report().prepared_number,
    })
    this.listenForChanges(this.form);
    this.formReady = true;
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true);
  }

  route() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 2 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  onChangeEditor(html: any, field: any) {
    if (html == '<p></p>') {
      let patch = '{"' + field + '": ""}'
      this.form.patchValue(JSON.parse(patch))
    }
  }

  gatherData(): any {
    let data: any = {
      report_name: this.form.value.report_name as string | null,
      report_type: this.form.value.report_type as string | null,
      h_code: this.form.value.h_code as string | null,

      date_contained: this.form.value.date_contained ? this.formatDate(this.form.value.date_contained) : null,
      prepared_name: this.form.value.prepared_name as string | null,
      prepared_address: this.form.value.prepared_address as string | null,
      prepared_number: this.form.value.prepared_number as string | null,
    };
    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }
    data.allFieldsFilled = allFieldsFilled
    return data
  }

  getTotalFunding() {
    let total = 0;
    this.reportList().forEach((report: any) => {
      report.forests.forEach((forest: ReportForest) => {
        total += this.forestTotal(forest.treatments);
      });
    })
    this.totalFunding = total;
  }

  forestTotal(treatments: any[] | undefined) {
    let total = 0;
    if (treatments == null) return 0
    for (let item of treatments) {
      total += this.unitTotal(item.treatment_specifications[0]) || 0; // ?? Does not cover NaN
    }
    return total;
  }

  unitTotal(item: any) {
    return (item.approved_unit_cost * item.approved_unit_qty) + (item.wo_approved_unit_cost * item.wo_approved_unit_qty);
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)
    if (!this.form.dirty && this.nav() == "") {
      if (navigate) {
        this.route()
      }
      // Don't save if nothing has changed on autosave
      return
    }
    let data = this.gatherData();

    if (!navigate && this.checkIfNotNeedToSave(data)) return

    this.saveSubject.next(null)
    this.status.emit(data.allFieldsFilled ? 2 : 1);

    this.accomplishmentService.updateAccomplishment({
      accomplishment_id: this.report().accomplishment_id,
      report_name: data.report_name,
      report_type: data.report_type,
      h_code: data.h_code,
      date_contained: data.date_contained,
      prepared_name: data.prepared_name,
      prepared_address: data.prepared_address,
      prepared_number: data.prepared_number,
      page_1_status_id: data.allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !data.allFieldsFilled) {
            this.form.markAllAsTouched();
            this.errorList = [];
            for (let field in this.form.controls) {
              const control = this.form.get(field);
              if (control?.invalid) {
                this.errorList.push(field.replaceAll('_', ' '));
              }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route(); // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave();
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
      complete: () => {
        this.form.markAsPristine();
        if (navigate) this.navDebounce = false
      }
    })
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  

  formatDate(value: string | Date): string | null {
    if (!value) {
      return null;
    }

    let year: number;
    let month: string;
    let day: string;

    if (typeof value === 'string') {
      const datePart = value.split('T')[0];
      const parts = datePart.split('-');

      year = Number(parts[0]);
      month = parts[1];
      day = parts[2];

      return `${month}/${day}/${year}`;
    }

    if (value instanceof Date) {
      year = value.getUTCFullYear();
      month = String(value.getUTCMonth() + 1).padStart(2, '0');
      day = String(value.getUTCDate()).padStart(2, '0');

      return `${month}/${day}/${year}`;
    }

    return null;
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }
}
